import { prebidStore } from "@/store/prebidStore";
import type { OzoneModule } from "@/ts/module";
import type { PageMiscData } from "@/ts/prebid/types";
import { getGoogleTag } from "@/utils/googletag";

export class Ozone implements OzoneModule {
	name = "Ozone" as const;

	async init(): Promise<void> {
		const gt = getGoogleTag();

		gt.cmd.push(() => {
			const storedTestGroup = gt.pubads().getTargeting("testgroup")[0];
			const testgroup = storedTestGroup
				? storedTestGroup
				: String(Math.floor(99 * Math.random()) + 1);

			if (!storedTestGroup) {
				gt.pubads().setTargeting("testgroup", testgroup);
			}

			const { actions } = prebidStore.getState();
			actions.setBidderData(getBidderData(testgroup));
		});
	}
}

// Module-scope: private to this file. Builds the data Ozone contributes
// to Prebid bid enrichment. Called during init() and result written to
// prebidStore so Prebid can read it without calling into this module directly.
const getBidderData = (testgroup: string): Partial<PageMiscData> => ({
	testgroup,
});
